import { render, staticRenderFns } from "./AzconCollectionCard.vue?vue&type=template&id=1e5b23ab&scoped=true"
import script from "./AzconCollectionCard.vue?vue&type=script&lang=js"
export * from "./AzconCollectionCard.vue?vue&type=script&lang=js"
import style0 from "./AzconCollectionCard.vue?vue&type=style&index=0&id=1e5b23ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5b23ab",
  null
  
)

export default component.exports